import { ReactNode } from 'react'
import styled from 'styled-components'

const MIDDLE_SIZE = 72
const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${MIDDLE_SIZE}px;
  align-items: start;

  & button {
    background-color: #0078c8;
    color: white;
    align-self: center;
    font-size: 13px;
  }

  & div.left {
    position: relative;
    /* border: 1px solid red; */
  }
  & div.middle {
    /* border: 1px solid red; */
    position: absolute;
    right: -${MIDDLE_SIZE/2}px;
    top: 50%;
    transform: translate(50%, -50%);
  }
`

interface IProps {
  left?: ReactNode;
  right?: ReactNode;
  middle?: ReactNode;
}

export const Pair: React.FC<IProps> = ({left, right, middle}) => {
  return (
    <Wrapper>
      { !left ? <div></div> :
        <div className='left'>
          {left}
          { !!middle &&
          <div className='middle'>
            {middle}
          </div>
          }
        </div>
      }
      { !!right ? right : <div></div>}
    </Wrapper>
  )
}
